<template>
	<div id="Main">
		<p class="title">{{title}}</p>
		<p class="textp" v-html="html"></p>
		<van-checkbox v-if="title!=''" v-model="checked" class="checkbox"><span class="label">本人已仔细阅读并完全同意<span class="a">《网上红利领取办理须知》</span></span></van-checkbox>
		<van-button v-if="title!=''" round type="info" class="button" @click="sure">确 定</van-button>
	</div>
</template>
<script>
	import axiosPost from '../../libs/moudle/index.js';
	export default {
		components: {},
		data() {
			return {
				checked: '',
				name:'',
				user:'',
				type:'',
				title:'',
				html:''
			}
		},
		methods: {
			sure() {
				if (this.checked) {
					if(this.type==1){
						this.$router.push({/* 红利 */
							path: '/applydividend',
							query:{
								user:this.user,
								name:this.name
							}
						})
					}else if(this.type==2){/* 过户 */
						this.$router.push({
							path: '/stockout',
							query:{
								user:this.user,
								name:this.name
							}
						})
					}else if(this.type==3){/* 过入 */
						this.$router.push({
							path: '/stockover',
							query:{
								user:this.user,
								name:this.name
							}
						})
					}else if(this.type==4){/* 质押 */
						this.$router.push({
							path: '/pledge',
							query:{
								user:this.user,
								name:this.name
							}
						})
					}else if(this.type==5){/* 解除质押 */
						this.$router.push({
							path: '/Relievepledge',
							query:{
								user:this.user,
								name:this.name
							}
						})
					}
				} else {
					this.$toast({duration:4000,message:'请选择并同意《'+this.title+'》'});
				}

			},
			getfile(id){
				this.$toast.loading({
					message: '数据加载中...',
					forbidClick: true,
					duration: 0
				});
				axiosPost.getfile({id:id}).then((res) => {
					this.$toast.clear();
					window.console.log(res.data)
					if (res.data.code == 1) {
						this.title=res.data.data.title
						this.html=res.data.data.content
					} else {
						window.console.log(res.data.msg)
					}
				}).catch((res) => {
					window.console.log(res)
				})
			}
		},
		mounted() {
			this.name = this.$route.query.name
			this.user = this.$route.query.user
			this.type = this.$route.query.type
			if(this.type==1){
				this.getfile(18);
			}else if(this.type==2 || this.type==3){
				this.getfile(15)
			}else if(this.type==4){
				this.getfile(16);
			}else{
				this.getfile(17);
			}
		}
	}
</script>

<style lang="scss" scoped>
	#Main {
		padding: 1.3rem;
		text-align: left;

		.title {
			font-size: 2rem;
			text-align: center;
			color: #666666;
			padding: 2rem 0;
			font-weight: bold;
		}

		.textp {
			font-size: 1.4rem;
			line-height: 2.4rem;
			color: #666666;
			padding-bottom: 0.4rem;
		}

		.texttitle {
			font-size: 1.4rem;
			line-height: 2.4rem;
			color: #666666;
			font-weight: bold;
			padding-bottom: 0.4rem;
		}

		.checkbox {
			padding: 1rem 0;
			font-size: 1.3rem;
			color: #999999;

			.label {
				color: #999999;
			}

			.a {
				color: #17b0fc;
			}
		}

		.button {
			width: 100%;
			background-color: #fa6b6b;
			border: 0;
			font-size: 2rem;
			margin: 1rem 0;
		}
	}
</style>
